import { createContext, useContext, useState } from "react";
import { DefaultShowCamera } from "lib/consts/inspections/camera";

export const CameraControlContext = createContext();
CameraControlContext.displayName = "InspectionCamera";
export const useCameraControl = () => useContext(CameraControlContext);

const CameraControlProvider = ({ children }) => {
    const [showCamera, setShowCamera] = useState(DefaultShowCamera);

    return (
        <CameraControlContext.Provider value={{ showCamera, setShowCamera }}>
            {children}
        </CameraControlContext.Provider>
    );
};

export default CameraControlProvider;
